import React from 'react';
import './Button.css';

const Button = ({
  children,
  variant = 'primary',
  onClick,
  disabled = false,
  className = '',
  type = 'button',
  style,
  // Anything else a <button> takes (title, aria-*, data-*) goes straight through — callers already passed
  // title= and it was silently dropped.
  ...rest
}) => {
  return (
    <button
      {...rest}
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={`btn btn-${variant} ${className}`}
      style={style}
    >
      {children}
    </button>
  );
};

export default Button;
